<template>
  <div class="tabs">
    <span
      v-for="(item,index) in tabs" :key="index"
      :class="[{ 'tabs_active': selectedTab.prop === item.prop }]"
      @click="tabClick(item)"
    >{{ item.label }}</span>
</div>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props:{
    tabs:{
      type:Array,
      default:()=>([])
    },
    selectedTab:{
      type:Object,
      default:()=>({})
    }
  },
  methods: {
    tabClick(item) {
      this.$emit('update:selectedTab',item)
    },
  },
})
</script>
